import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Footer from './Footer/Footer';
import Reminder from './Reminder/Reminder.js';
import Receipt from './Receipt/Receipt.js';
import './App.css';
import Home from './Home/Home.js';
import Statistics from './Statistics/Statistics.js';
import AddNewExpense from './AddNewExpense/AddNewExpense.js';
import Login from './Login/Login.js';
import ProfilePage from './ProfilePage/ProfilePage.js';
import Register from './Register/Register.js';
import SplashPage from './SplashPage/SplashPage.js';

const AppContent = () => {
  const location = useLocation();

  return (
    <div className="app">
      <div className="main-content">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/welcome" element={<SplashPage />} />
          <Route path="/register" element={<Register />} />
          <Route path="/" element={<Home />} />
          <Route path="/add-expense" element={<AddNewExpense />} />
          <Route path="/reminder" element={<Reminder />} />
          <Route path="/receipt" element={<Receipt />} />
          <Route path="/statistics" element={<Statistics />} />
          <Route path="/profile" element={<ProfilePage />} />
        </Routes>
      </div>
      {location.pathname !== '/login' && location.pathname !== '/register' && location.pathname !== '/welcome' && <Footer />}
    </div>
  );
};

const App = () => (
  <Router>
    <AppContent />
  </Router>
);

export default App;
